import { render, staticRenderFns } from "./departure.vue?vue&type=template&id=4791f79c&scoped=true"
import script from "./departure.vue?vue&type=script&lang=js"
export * from "./departure.vue?vue&type=script&lang=js"
import style0 from "./departure.vue?vue&type=style&index=0&id=4791f79c&prod&lang=css"
import style1 from "./departure.vue?vue&type=style&index=1&id=4791f79c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4791f79c",
  null
  
)

export default component.exports